(() => {
  const SIZE_WORDS = ['taille', 'size'];

  function normalize(value) {
    return (value || '')
      .toString()
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function isSizePicker(wrapper) {
    const legend = wrapper.querySelector('legend, .form__label, label');
    const legendText = normalize(legend ? legend.textContent : '');

    if (SIZE_WORDS.some((word) => legendText === word || legendText.includes(word))) return true;

    const nameValues = Array.from(wrapper.querySelectorAll('input[type="radio"]'))
      .map((input) => normalize(input.getAttribute('name') || input.getAttribute('data-option-name') || input.id || ''))
      .join(' ');

    return SIZE_WORDS.some((word) => nameValues.includes(word));
  }

  function initSizePills(root = document) {
    const scope = root && root.querySelectorAll ? root : document;
    const candidates = scope.querySelectorAll(
      'variant-radios fieldset, variant-selects fieldset, .product-form__input, fieldset.product-form__input'
    );

    candidates.forEach((wrapper) => {
      if (!wrapper.querySelector('input[type="radio"] + label')) return;
      if (!isSizePicker(wrapper)) return;

      wrapper.classList.add('mc-size-option-picker');
    });
  }

  function boot() {
    initSizePills();
    setTimeout(initSizePills, 250);
    setTimeout(initSizePills, 800);
    setTimeout(initSizePills, 1600);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) initSizePills(node);
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => initSizePills(event.target));
})();
